import { register } from "@teamhanko/hanko-elements"
import { createMemo, createSignal, onMount } from "solid-js"
import { useAppContext } from "@/context/app"
import { Box } from "@/designSystem/components/box"
import { Form } from "@/designSystem/components/form"
import { Select } from "@/designSystem/components/select"
import { MainLayout } from "@/designSystem/layouts/mainLayout"
import { Navigation } from "@/designSystem/patterns/navigation"

type GlobalJsx = JSX.IntrinsicElements

declare module "solid-js" {
  namespace JSX {
    interface IntrinsicElements {
      "hanko-profile": GlobalJsx["hanko-profile"]
    }
  }
}

const OPTIONS = [
  {
    value: null,
    label: "Never",
    disabled: false,
  },
  {
    value: "daily",
    label: "Daily",
    disabled: false,
  },
  {
    value: "weekly",
    label: "Weekly",
    disabled: false,
  },
] as const
type EmailDigest = (typeof OPTIONS)[number]["value"]

export function Settings() {
  const { user, replicache } = useAppContext()
  const email = createMemo(() => user.email)
  const [emailDigest, setEmailDigest] = createSignal<EmailDigest | null>(
    user.email_digest,
  )
  const hankoUrl = import.meta.env.VITE_FIKA_HANKO_API_URL
  const dirty = createMemo(() => emailDigest() !== user.email_digest)

  onMount(() => {
    register(hankoUrl).catch(error => {
      console.error(error)
      // handle error
    })
  })

  function handleSubmit() {
    replicache.mutate.updateEmailDigest({
      id: user.id,
      email_digest: emailDigest() ?? null,
    })
  }

  return (
    <MainLayout header={<Navigation hue="orange" title="settings" />}>
      <Box gap="24">
        <Form
          title="Email Newsletter"
          description={`Receive a digest email to "${email()}" with the new stories from your feeds`}
          hue="orange"
          iconName="mail"
          onSubmit={handleSubmit}
        >
          <Select
            hue="orange"
            label="Frequency"
            options={[...OPTIONS]}
            value={emailDigest}
            onChange={setEmailDigest}
          />
          <Form.Save hue="orange" iconName="newspaper" disabled={!dirty()} />
        </Form>
        <Form
          title="Authentication"
          description="Manage your account"
          hue="orange"
          iconName="lock"
        >
          <hanko-profile />
        </Form>
      </Box>
    </MainLayout>
  )
}
